import { capitaliseSentence } from "./capitaliseSentence";

export const deSnakeCase = (text: string) => {
    return capitaliseSentence(text.split("_").join(" "));
};
